import { useEffect } from 'react'
import { useLocation } from 'react-router'
import { getPageSeo, renderSeoHead } from '@/content/seo'

export function PageSeo() {
  const { pathname } = useLocation()
  useEffect(() => {
    const seo = getPageSeo(pathname)
    document.documentElement.lang = seo.locale
    document.head.querySelectorAll('[data-seo], title').forEach((node) => node.remove())
    const template = document.createElement('template')
    template.innerHTML = renderSeoHead(seo)
    document.head.append(template.content)
  }, [pathname])
  return null
}
